import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Container, Image, Button, FormLabel } from "react-bootstrap";
import { Document } from "react-pdf";
import { Page } from "react-pdf";
import CustomButton from "../../../components/UI/Button/Button";
import Input from "../../../components/UI/Input/Input";
import * as actions from "../../../store/actions/index.js";
import Spinner from "../../../components/UI/Spinner/Spinner";
import NetworkAlert from "../../../components/UI/NetworkAlert/NetworkAlert";
import Modal from "../../../components/UI/Modal/Modal";
import DiscardBilling from "../DiscardBilling/DiscardBilling";
import UploadSuccessful from "../UploadSuccessful/UploadSuccessful";
import ProviderBillsBrowseImages from "../UploadBills/BrowseImages/BrowseImages";
import PatientsResonsibilityBrowseImages from "../PatientsResponsibility/BrowsePatientsResponsibility/BrowsePatientsResponsibility";
import ExplanationOfBenefitsBrowseImages from "../ExplanationOfBenefits/BrowseExplanationOfBenefits/BrowseExplanationOfBenefits";
import ViewPatientsResponsibility from "../PatientsResponsibility/ViewPatientsResponsibility/ViewPatientsResponsibility";
import ViewExplanationOfBenefits from "../ExplanationOfBenefits/ViewExplanationOfBenefits/ViewExplanationOfBenefits";
import ViewingBills from "../UploadBills/ViewingBills/ViewingBills";
import NumberFormat from "react-number-format";
import ViewDisputeAuthorization from "../DisputeAuthorization/ViewDisputeSuthorization/ViewDisputeAuthorization";
import { logFirebaseEvent, updateObject } from "../../../shared/utility";
import jsPDF from "jspdf";
import errorStrings from "../../../errorMessages";

import classes from "./SubmitBills.module.css";

import dollar from "../../../assets/images/icon-dollar-small.svg";
import sign from "../../../assets/images/icon-doc-sign.svg";
// import BalanceBilling from "../BalanceBilling";

interface IStateFromProps {
  // loadingDocumentTypes: boolean;
  // errorDocumentTypes: boolean;
  documentTypes: {
    id: string;
    type: string;
    editable: boolean;
    order: number;
  }[];
  providerBills: File[];
  patientsResponsibilityBills: File[];
  explanationOfBenefitsBills: File[];
  disputeAuthorizationForm: string;
  newUploadData: {
    claimId: number;
    beneficiarySelected: string;
    dateOfService: string;
    procedureLabel: string;
    providerName: string;
    totalChargeAmount: number;
    isMinor: boolean;
    primaryAccountHolder: boolean;
    patientId: number;
    ampsId: string;
  };
  loadingSubmitBills: boolean;
  loadingUserInfo: boolean;
  submittedBills: boolean;
  errorSubmitBills: boolean;
  errorMessageSubmitBills: string;
  bestContactInfo: { phone: string; email: string };
  userInfo: {
    TPA: string;
    memberId: string | null;
    groupId: number;
    patientName: string;
  };
  submittedBillsDetails: {
    id: number;
    claimId: number;
    fileName: string;
    extension: string;
    fileSize: number;
    uploadDate: string;
  }[];
  t: any;
  loadingSubmitContactInformation: boolean;
  loadingSubmitClaim: boolean;
  submittedSubmitClaim: boolean;
  submittedContactInformation: boolean;
  errorSubmitContactInformation: boolean;
  errorMessageSubmitContactInformation: string;
  errorSubmitClaim: boolean;
  errorMessageSubmitClaim: string;
  balanceBillView: string;
  shouldUploadDocument: boolean;
  updateAddressParams: {
    patientId: string;
    phone: string;
    email: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
  };
  submittedDAF: boolean;
  loadingDAF: boolean;
  errorDAF: boolean;
  loadingSubmitUpdatedAddress: boolean;
  errorSubmitUpdatedAddress: boolean;
  submittedSubmitUpdatedAddress: boolean;
  errorMessageSubmitUpdatedAddress: string;
  errorMessageDAF: string;
}
interface IDispatchFromProps {
  onFetchUserInfo: (patientId: number) => void;
  // onFetchDocumentTypes: (userId: string) => void;
  onSubmitBills: (formData: FormData) => void;
  onSubmitContactInformation: (contactInfo: {
    claimId: number;
    patientId: number;
    phoneNumber: string;
    email: string;
  }) => void;
  onSubmitBalanceBillingClaim: (claimDetails: {
    procedureLabel: string;
    claimId: number;
    patientId: number;
    dateOfService: string;
    facility: string;
    totalChargeAmount: number;
    document: {
      id: string;
    }[];
  }) => void;
  onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  onResetDisputeAuthorizationFile: () => void;
  onResetSubmitBills: () => void;
  onResetSubmitBalanceBillingClaim: () => void;
  onResetSubmitContactInformation: () => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  onSubmitDAF: (formData: FormData) => void;
  onShouldUploadDocument: (shouldUpload: boolean) => void;
  onSubmitUpdatedAddress: (updatedAddress: {
    patientId: string;
    phone: string;
    email: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
  }) => void;
  onSubmitBestContactInfo: (any) => void;
  onResetBestContactInfo: () => void;
  onConstructUpdatedAddress: (name: string, value: string) => void;
}
interface IState {
  discardingBills: boolean;
  submittingBills: boolean;
  providerBillsUploading: boolean;
  patientsResponsibilityBillsUploading: boolean;
  explanationOfBenefitsBillsUploading: boolean;
  viewingProviderBills: boolean;
  viewingPatientsResponsibilityBills: boolean;
  viewingExplanationOfBenefitsBills: boolean;
  viewingDisputeAuthorizationForm: boolean;
  viewBillNumber: number;
  bestContactInfo: {
    phone: string;
    email: string;
  };
  errorPhone: string;
  errorEmail: string;
  formValid: boolean;
  documentTypesAdded: {
    id: string;
  }[];
  showOverviewOfBills: boolean;
}
type Props = IStateFromProps & IDispatchFromProps & RouteComponentProps;

class SubmitBills extends Component<Props> {
  state: IState = {
    discardingBills: false,
    submittingBills: false,
    providerBillsUploading: false,
    patientsResponsibilityBillsUploading: false,
    explanationOfBenefitsBillsUploading: false,
    viewingProviderBills: false,
    viewingPatientsResponsibilityBills: false,
    viewingExplanationOfBenefitsBills: false,
    viewingDisputeAuthorizationForm: false,
    viewBillNumber: 0,
    bestContactInfo: {
      phone: this.props.bestContactInfo.phone,
      email: this.props.bestContactInfo.email,
    },
    errorPhone: "",
    errorEmail: "",
    formValid: false,
    documentTypesAdded: [],
    showOverviewOfBills: false,
  };

  providerBillsBase64: string[] = [];
  discardBillsHandler = () => {
    this.setState({ discardingBills: true });
  };
  donotDiscardBillsHandler = () => {
    this.setState({ discardingBills: false });
  };
  submitDoneHandler = (goToHome) => {
    this.setState({ submittingBills: false });
    this.setState({ documentTypesAdded: [] });
    // this.props.onSetBalanceBillViewState("getStarted");
    this.props.onResetSubmitBills();
    this.props.onResetSubmitBalanceBillingClaim();
    this.props.onResetSubmitContactInformation();
    // if (goToHome) {
    //   this.props.history.push("/");
    // }
    if (goToHome) {
      this.props.onSetBalanceBillViewState("");
      this.props.onRemoveProviderBillsFiles([]);
      this.props.onRemovePatientsResponsibilityFiles([]);
      this.props.onRemoveExplanationOfBenefitsFiles([]);
      this.props.onResetDisputeAuthorizationFile();
      this.props.onShouldUploadDocument(false);
      this.props.onResetBestContactInfo();
    }
  };
  encodeFileBase64 = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        // reader.onload = () => {
        //   let result = reader.result as string;
        //   this.providerBillsBase64.push(result.split(",")[1]);
        //   console.log("providerBillsBase64", this.providerBillsBase64);
        //   // console.log("resultArray", resultArray);
        //   // console.log("resultArray after split",resultArray[0].split(',')[1]);
        // };
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject("Can't convert");
      }
    });
  };
  makePDF(image, resultArray) {
    console.log("image ", image);
    console.log("image resultArray ", resultArray);
    var doc = new jsPDF();
    doc.addImage(image, "JPEG", 0, 0, 210, 297);
    //doc.save("test.pdf");
    // doc.output("arraybuffer");
    //window.open(doc.output("dataurlstring") as any, "_blank");
    resultArray.push(doc.output("blob"));
  }
  submitHandler = async () => {
    console.log(this.props.newUploadData);
    const fd = new FormData();
    // fd.append("claimId", this.props.newUploadData.claimId.toString());
    fd.append(
      "totalChargeAmount",
      this.props.newUploadData.totalChargeAmount.toString()
    );
    fd.append("patientId", this.props.newUploadData.patientId.toString());
    fd.append("dateOfService", this.props.newUploadData.dateOfService);
    // if (
    //   process.env.REACT_APP_BUILD_ENVIRONMENT?.toLowerCase() === "qa" ||
    //   process.env.REACT_APP_BUILD_ENVIRONMENT?.toLowerCase() === "production"
    // ) {
    //   fd.append("patientId", this.props.newUploadData.patientId.toString());
    // } else {
    //   fd.append(
    //     "patientId",
    //     this.props.newUploadData.procedureLabel.toString()
    //   );
    // }
    let fileNames: string[] = [];
    let documentIdsToAdd;
    let updateDocumentTypesAdded: { id: string }[] = [];
    let billsToPdf = [];
    // var downloadPdf = (blob, fileName) => {
    //   const link = document.createElement("a");
    //   link.href = URL.createObjectURL(blob);
    //   link.download = fileName;
    //   document.body.append(link);
    //   link.click();
    //   link.remove();
    //   setTimeout(() => URL.revokeObjectURL(link.href), 2000);
    // };
    /*provider billing statement*/
    if (this.props.providerBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 1
      );

      billsToPdf = [];
      for (let i = 0; i < this.props.providerBills.length; i++) {
        console.log("providerBills ", i);
        if (!this.props.providerBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.providerBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // downloadPdf( billsToPdf[i], "bill.pdf");
            // fileNames.push(`${documentIdsToAdd.type}_${i}`);
            //fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.providerBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...this.state.documentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /*proof of payment receipts*/
    if (this.props.patientsResponsibilityBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 3
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.patientsResponsibilityBills.length; i++) {
        console.log("patientsResponsibilityBills ", i);
        if (!this.props.patientsResponsibilityBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.patientsResponsibilityBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.patientsResponsibilityBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...updateDocumentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    /*explanation of benefits*/
    if (this.props.explanationOfBenefitsBills.length > 0) {
      documentIdsToAdd = this.props.documentTypes.find(
        (documentType) => documentType.order === 4
      );
      billsToPdf = [];
      for (let i = 0; i < this.props.explanationOfBenefitsBills.length; i++) {
        console.log("explanationOfBenefitsBills ", i);
        if (!this.props.explanationOfBenefitsBills[i].name.includes("pdf")) {
          let bill: any = await this.encodeFileBase64(
            this.props.explanationOfBenefitsBills[i]
          );
          if (bill !== "Can't convert") {
            this.makePDF(bill, billsToPdf);
            console.log("billsToPdf", billsToPdf);
            // fd.append("files", billsToPdf[i], "application/pdf");
            // fileNames.push(`${documentIdsToAdd.type}`);
          }
        } else {
          fd.append("files", this.props.explanationOfBenefitsBills[i]);
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          fd.append("files", billsToPdf[i], "application/pdf");
          fileNames.push(`${documentIdsToAdd.type}`);
        }
      }
      updateDocumentTypesAdded = [
        ...updateDocumentTypesAdded,
        { id: documentIdsToAdd.id },
      ];
    }
    // /* Dispute Authorization form */
    // if (this.props.disputeAuthorizationForm) {
    //   documentIdsToAdd = this.props.documentTypes.find(
    //     (documentType) => documentType.order === 2
    //   );
    //   console.log(this.props.disputeAuthorizationForm);
    //   // let disputeAuthorizationFormBlob = arrayBufferToBlob(
    //   //   this.props.disputeAuthorizationForm
    //   // );
    //   // console.log(disputeAuthorizationFormBlob);
    //   billsToPdf = [];
    //   let bill: any = await this.encodeFileBase64(
    //     this.props.disputeAuthorizationForm
    //   );
    //   if (bill !== "Can't convert") {
    //     this.makePDF(bill, billsToPdf);
    //     console.log("billsToPdf", billsToPdf);
    //     // fd.append("files", billsToPdf[0], "application/pdf");
    //     // fileNames.push(`${documentIdsToAdd.type}`);
    //   }
    //   if (billsToPdf.length > 0) {
    //     for (let i = 0; i < billsToPdf.length; i++) {
    //       fd.append("files", billsToPdf[i], "application/pdf");
    //       fileNames.push(`${documentIdsToAdd.type}`);
    //       const fd1 = new FormData();
    //       // fd.append("claimId", this.props.newUploadData.claimId.toString());
    //       // fd1.append(
    //       //   "totalChargeAmount",
    //       //   this.props.newUploadData.totalChargeAmount.toString()
    //       // );
    //       fd1.append(
    //         "patientId",
    //         this.props.newUploadData.patientId.toString()
    //       );
    //       fd1.append("file", billsToPdf[i], "application/pdf");
    //       fd1.append("file", "sample.png");
    //       this.props.onSubmitDAF(fd1);
    //     }
    //   }
    //   // fd.append("files", this.props.disputeAuthorizationForm);
    //   // fileNames.push(`${documentIdsToAdd.type}`);
    //   updateDocumentTypesAdded = [
    //     ...updateDocumentTypesAdded,
    //     { id: documentIdsToAdd.id },
    //   ];
    // }
    // let js = JSON.stringify([]);
    let jsonstr = JSON.stringify(fileNames);
    fd.append("fileNames", jsonstr);

    console.log(fd);
    if (this.validateForm()) {
      logFirebaseEvent("BalanceBillSubmitButtonPressed");
      const { phone, email } = this.state.bestContactInfo;

      let phoneNum = phone.replace(/[^0-9]/g, "");

      const formData = { phoneNum, email };
      this.props.onConstructUpdatedAddress("phone", phoneNum);
      this.props.onConstructUpdatedAddress("email", email);
      this.props.onConstructUpdatedAddress(
        "patientId",
        this.props.newUploadData.patientId.toString()
      );
      console.log(formData);
      this.setState({ patientsResponsibilityStatement: true });
      this.props.onSubmitBestContactInfo({ phone: phoneNum, email });
      this.props.onSubmitBills(fd);
      this.setState({ documentTypesAdded: updateDocumentTypesAdded });
      this.setState({ submittingBills: true });
    }
  };
  submitDAFHandler = async () => {
    if (this.props.disputeAuthorizationForm) {
      let billsToPdf = [];
      let bill: any = await this.encodeFileBase64(
        this.props.disputeAuthorizationForm
      );
      if (bill !== "Can't convert") {
        this.makePDF(bill, billsToPdf);
        console.log("billsToPdf", billsToPdf);
        // fd.append("files", billsToPdf[0], "application/pdf");
        // fileNames.push(`${documentIdsToAdd.type}`);
      }
      if (billsToPdf.length > 0) {
        for (let i = 0; i < billsToPdf.length; i++) {
          const fd1 = new FormData();
          fd1.append(
            "patientId",
            this.props.newUploadData.patientId.toString()
          );
          fd1.append("file", billsToPdf[i], "application/pdf");
          fd1.append("file", "sample.png");
          this.props.onSubmitDAF(fd1);
        }
      }
    }
  };
  componentDidUpdate(prevProps, prevState) {
    console.log(
      "this.props.shouldUploadDocument",
      this.props.shouldUploadDocument
    );

    if (
      this.props.submittedBills !== prevProps.submittedBills &&
      this.props.submittedBills === true
    ) {
      if (this.props.shouldUploadDocument === true) {
        console.log(this.props.updateAddressParams);
        /* Dispute Authorization form */
        this.submitDAFHandler();
      } else {
        // this.props.onSubmitContactInformation({
        //   claimId: this.props.submittedBillsDetails[0].claimId,
        //   patientId: this.props.newUploadData.patientId,
        //   phoneNumber: this.props.bestContactInfo.phone,
        //   email: this.props.bestContactInfo.email,
        // });
        this.props.onSubmitContactInformation({
          claimId: this.props.submittedBillsDetails[0].claimId,
          patientId: this.props.newUploadData.patientId,
          phoneNumber: this.props.bestContactInfo.phone.trim(),
          email: this.props.bestContactInfo.email.trim(),
        });
      }
      // if (this.props.shouldUploadDocument === true) {
      //   console.log(this.props.updateAddressParams);
      // }
    } else if (
      this.props.submittedDAF !== prevProps.submittedDAF &&
      this.props.submittedDAF === true
    ) {
      this.props.onSubmitUpdatedAddress(this.props.updateAddressParams);
    } else if (
      this.props.submittedSubmitUpdatedAddress !==
        prevProps.submittedSubmitUpdatedAddress &&
      this.props.submittedSubmitUpdatedAddress === true
    ) {
      this.props.onSubmitContactInformation({
        claimId: this.props.submittedBillsDetails[0].claimId,
        patientId: this.props.newUploadData.patientId,
        phoneNumber: this.props.bestContactInfo.phone.trim(),
        email: this.props.bestContactInfo.email.trim(),
      });
    } else if (
      this.props.submittedContactInformation !==
        prevProps.submittedContactInformation &&
      this.props.submittedContactInformation === true
    ) {
      const submitClaim = {
        procedureLabel: this.props.newUploadData.procedureLabel,
        claimId: this.props.submittedBillsDetails[0].claimId,
        patientId: this.props.newUploadData.patientId,
        dateOfService: this.props.newUploadData.dateOfService,
        facility: this.props.newUploadData.providerName,
        totalChargeAmount: +this.props.newUploadData.totalChargeAmount,
        document: this.state.documentTypesAdded,
      };
      this.props.onSubmitBalanceBillingClaim(submitClaim);
    } else if (
      this.props.submittedSubmitClaim !== prevProps.submittedSubmitClaim
    ) {
    }
    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      if (this.props.balanceBillView === "") {
        this.setState({ showOverviewOfBills: true });
      } else if (this.props.balanceBillView === "submitBills") {
        this.setState({ showOverviewOfBills: false });
      }
    }
  }
  componentDidMount() {
    logFirebaseEvent("BalanceBillDetails");
    this.props.onFetchUserInfo(this.props.newUploadData.patientId);
    // this.props.onFetchDocumentTypes(localStorage.getItem("userId")!);
  }

  confirmDiscardBillsHandler = () => {
    this.props.onResetDisputeAuthorizationFile();
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onResetSubmitBills();
    this.props.onResetSubmitBalanceBillingClaim();
    this.props.onResetSubmitContactInformation();
    this.props.onShouldUploadDocument(false);
    this.setState({ discardingBills: false });
    this.props.history.push("/");
  };

  handleChange = (e) => {
    this.setState({ formValid: false });
    const updateContactParam = {
      [e.target.name]: e.target.value,
    };
    const updateContactInfo = updateObject(
      this.state.bestContactInfo,
      updateContactParam
    );
    this.setState({
      bestContactInfo: updateContactInfo,
      errorPhone: "",
      errorEmail: "",
    });
  };

  validateForm = () => {
    let phone = this.state.bestContactInfo.phone;
    let email = this.state.bestContactInfo.email;
    let formIsValid = true;

    let phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // (123) 123-1234;

    if (!phonePattern.test(phone)) {
      formIsValid = false;
      this.setState({
        errorPhone: this.props.t("errorMsg.errorPhone"),
      });
    }
    let emailPattern =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    if (!emailPattern.test(String(email).toLowerCase())) {
      formIsValid = false;
      this.setState({
        errorEmail: this.props.t("errorMsg.errorEmail"),
      });
    }
    return formIsValid;
  };
  deleteProviderBillsHandler = (index: number) => {
    var array = [...this.props.providerBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveProviderBillsFiles(array);
    }
  };

  deletePatientsResponsibilityHandler = (index: number) => {
    var array = [...this.props.patientsResponsibilityBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemovePatientsResponsibilityFiles(array);
    }
  };

  deleteExplanationOfBenefitsHandler = (index: number) => {
    var array = [...this.props.explanationOfBenefitsBills];
    if (index !== -1) {
      array.splice(index, 1);
      this.props.onRemoveExplanationOfBenefitsFiles(array);
    }
  };
  uploadProviderBillsHandler = () => {
    this.setState({ providerBillsUploading: true });
  };
  uploadedProviderBillsHandler = () => {
    this.setState({ providerBillsUploading: false });
  };
  uploadPatientsResponsibilityBillsHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: true });
  };
  uploadedPatientsResponsibilityBillsHandler = () => {
    this.setState({ patientsResponsibilityBillsUploading: false });
  };
  uploadExplanationOfBenefitsBillsHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: true });
  };
  uploadedExplanationOfBenefitsBillsHandler = () => {
    this.setState({ explanationOfBenefitsBillsUploading: false });
  };
  viewingProviderBillsHandler = (index: number) => {
    this.setState({ viewBillNumber: index });
    this.setState({ viewingProviderBills: true });
  };
  closeViewingProviderBillsHandler = () => {
    this.setState({ viewingProviderBills: false });
  };
  viewingPatientsResponsibilityBillsHandler = (index: number) => {
    this.setState({ viewBillNumber: index });
    this.setState({ viewingPatientsResponsibilityBills: true });
  };
  closeViewingPatientsResponsibilityBillsHandler = () => {
    this.setState({ viewingPatientsResponsibilityBills: false });
  };
  viewingExplanationOfBenefitsBillsHandler = (index: number) => {
    this.setState({ viewBillNumber: index });
    this.setState({ viewingExplanationOfBenefitsBills: true });
  };
  closeViewingExplanationOfBenefitsBillsHandler = () => {
    this.setState({ viewingExplanationOfBenefitsBills: false });
  };

  viewingDisputeAuthorizationHandler = () => {
    this.setState({ viewingDisputeAuthorizationForm: true });
  };
  closeViewingDisputeAuthorizationHandler = () => {
    this.setState({ viewingDisputeAuthorizationForm: false });
  };
  render() {
    // console.log("this.props.newUploadData", this.props.newUploadData);
    console.log(
      "this.props.shouldUploadDocument",
      this.props.shouldUploadDocument
    );
    const { t } = this.props;
    console.log("this.props.newUploadData", this.props.newUploadData);
    const nextBtnStyle = {
      minWidth: "150px",
    };
    const elementLabelStyle = {
      fontSize: "13px",
      fontWeight: "600",
      color: "#117093",
      marginBottom: "3px",
    };
    const modalChildStyle = {};
    const modalDiscard = {
      width: "350px",
      left: "calc(50% - 175px)",
    };
    const modalViewBillStyle = {
      width: "700px",
      left: "calc(50% - 350px)",
      top: "15%",
      position: "absolute",
    };

    let viewProviderBills: any;
    if (this.state.viewingProviderBills) {
      viewProviderBills = (
        <Modal
          show={this.state.viewingProviderBills}
          childComp={
            <ViewingBills
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingProviderBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewPatientsResponsibilityBills: any;
    if (this.state.viewingPatientsResponsibilityBills) {
      viewPatientsResponsibilityBills = (
        <Modal
          show={this.state.viewingPatientsResponsibilityBills}
          childComp={
            <ViewPatientsResponsibility
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingPatientsResponsibilityBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewExplanationOfBenefitsBills: any;
    if (this.state.viewingExplanationOfBenefitsBills) {
      viewExplanationOfBenefitsBills = (
        <Modal
          show={this.state.viewingExplanationOfBenefitsBills}
          childComp={
            <ViewExplanationOfBenefits
              viewBillNumber={this.state.viewBillNumber}
              closeViewing={this.closeViewingExplanationOfBenefitsBillsHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let viewDisputeAuthorizationForm: any;
    if (this.state.viewingDisputeAuthorizationForm) {
      viewDisputeAuthorizationForm = (
        <Modal
          show={this.state.viewingDisputeAuthorizationForm}
          childComp={
            <ViewDisputeAuthorization
              closeViewing={this.closeViewingDisputeAuthorizationHandler}
            />
          }
          style={modalViewBillStyle}
        />
      );
    }

    let providerBillsUpload: any;
    if (this.state.providerBillsUploading) {
      providerBillsUpload = (
        <Modal
          show={this.state.providerBillsUploading}
          childComp={
            <ProviderBillsBrowseImages
              modalClosed={this.uploadedProviderBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    let patientsResponsibilityBillsUpload: any;
    if (this.state.patientsResponsibilityBillsUploading) {
      patientsResponsibilityBillsUpload = (
        <Modal
          show={this.state.patientsResponsibilityBillsUploading}
          childComp={
            <PatientsResonsibilityBrowseImages
              modalClosed={this.uploadedPatientsResponsibilityBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    let explanationOfBenefitsBillsUpload: any;
    if (this.state.explanationOfBenefitsBillsUploading) {
      explanationOfBenefitsBillsUpload = (
        <Modal
          show={this.state.explanationOfBenefitsBillsUploading}
          childComp={
            <ExplanationOfBenefitsBrowseImages
              modalClosed={this.uploadedExplanationOfBenefitsBillsHandler}
            />
          }
          style={{}}
        />
      );
    }

    /*contact information is last API to hit, displaying response on it's success*/
    let submitBills: any;
    if (this.props.submittedSubmitClaim) {
      submitBills = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <UploadSuccessful
              modalClosed={() => this.submitDoneHandler(true)}
              heading={t("submitBill.heading")}
              subHeading={t("submitBill.subHeading")}
            />
          }
          style={modalChildStyle}
        />
      );
    }
    // /* show overview of bills*/
    // let overviewOfBills: any;
    // if (this.state.showOverviewOfBills) {
    //   overviewOfBills = <BalanceBilling />;
    // }
    /* Error Modal */
    let errorDisplay: any;
    if (this.props.errorSubmitBills) {
      errorDisplay = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={
                errorStrings(this.props.errorMessageSubmitBills)
                  ? t(errorStrings(this.props.errorMessageSubmitBills))
                  : this.props.errorMessageSubmitBills
              }
            />
          }
          style={modalChildStyle}
        />
      );
    }
    let errorDisplaySubmitClaim: any;
    if (this.props.errorSubmitClaim) {
      errorDisplaySubmitClaim = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={
                errorStrings(this.props.errorMessageSubmitClaim)
                  ? t(errorStrings(this.props.errorMessageSubmitClaim))
                  : this.props.errorMessageSubmitClaim
              }
            />
          }
          style={modalChildStyle}
        />
      );
    }
    let errorDisplaySubmitContactInformation: any;
    if (this.props.errorSubmitContactInformation) {
      errorDisplaySubmitContactInformation = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={
                errorStrings(this.props.errorMessageSubmitContactInformation)
                  ? t(
                      errorStrings(
                        this.props.errorMessageSubmitContactInformation
                      )
                    )
                  : this.props.errorMessageSubmitContactInformation
              }
            />
          }
          style={modalChildStyle}
        />
      );
    }

    let errorDisplaySubmitUpdatedAddress: any;
    if (this.props.errorSubmitUpdatedAddress) {
      errorDisplaySubmitUpdatedAddress = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={this.props.errorMessageSubmitUpdatedAddress}
            />
          }
          style={modalChildStyle}
        />
      );
    }

    let errorDisplayDAF: any;
    if (this.props.errorDAF) {
      errorDisplayDAF = (
        <Modal
          show={this.state.submittingBills}
          childComp={
            <NetworkAlert
              modalClosed={() => this.submitDoneHandler(false)}
              error={this.props.errorMessageDAF}
            />
          }
          style={modalChildStyle}
        />
      );
    }

    const discardBills = (
      <Modal
        show={this.state.discardingBills}
        childComp={
          <DiscardBilling
            cancelDiscard={this.donotDiscardBillsHandler}
            confirmDiscard={this.confirmDiscardBillsHandler}
          />
        }
        style={modalDiscard}
      />
    );

    let providerBillsPreview: any;
    if (this.props.providerBills && this.props.providerBills.length > 0) {
      providerBillsPreview = (
        <div className="uploadPreviews upload-preview">
          {(this.props.providerBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() => this.viewingProviderBillsHandler(index)}
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() => this.viewingProviderBillsHandler(index)}
                  />
                )}
              </div>
              {/* <span
                className="closeBtn"
                onClick={() => this.deleteProviderBillsHandler(index)}
              >
                <span>x</span>
              </span> */}
            </div>
          ))}
        </div>
      );
    }

    let patientsResponsibilityPreview: any;
    if (
      this.props.patientsResponsibilityBills &&
      this.props.patientsResponsibilityBills.length > 0
    ) {
      patientsResponsibilityPreview = (
        <div className="uploadPreviews upload-preview">
          {(this.props.patientsResponsibilityBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingPatientsResponsibilityBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingPatientsResponsibilityBillsHandler(index)
                    }
                  />
                )}
              </div>
              {/* <span
                className="closeBtn"
                onClick={() => this.deletePatientsResponsibilityHandler(index)}
              >
                <span>x</span>
              </span> */}
            </div>
          ))}
        </div>
      );
    }

    let explanationOfBenefitsPreview: any;
    if (
      this.props.explanationOfBenefitsBills &&
      this.props.explanationOfBenefitsBills.length > 0
    ) {
      explanationOfBenefitsPreview = (
        <div className="uploadPreviews upload-preview">
          {(this.props.explanationOfBenefitsBills || []).map((url, index) => (
            <div className="uploadPreview" key={`file${index}`}>
              <div className="previewThumb">
                {url.name.includes("pdf") ? (
                  <Document file={url}>
                    <Page
                      pageNumber={1}
                      onClick={() =>
                        this.viewingExplanationOfBenefitsBillsHandler(index)
                      }
                    />
                  </Document>
                ) : (
                  <img
                    src={URL.createObjectURL(url)}
                    alt="..."
                    onClick={() =>
                      this.viewingExplanationOfBenefitsBillsHandler(index)
                    }
                  />
                )}
              </div>
              {/* <span
                className="closeBtn"
                onClick={() => this.deleteExplanationOfBenefitsHandler(index)}
              >
                <span>x</span>
              </span> */}
            </div>
          ))}
        </div>
      );
    }

    let disputeAuthorizationPreview: any;
    if (this.props.disputeAuthorizationForm) {
      disputeAuthorizationPreview = (
        <div className="uploadPreviews upload-preview">
          <div className="uploadPreview">
            <div className="previewThumb">
              {/* {console.log("url is ", this.props.disputeAuthorizationForm.name)} */}
              <img
              //@ts-ignore
                src={URL.createObjectURL(this.props.disputeAuthorizationForm)}
                alt="..."
                onClick={this.viewingDisputeAuthorizationHandler}
              />
            </div>
          </div>
        </div>
      );
    }
    let spinner: any;
    if (
      this.props.loadingSubmitBills ||
      this.props.loadingSubmitClaim ||
      this.props.loadingSubmitContactInformation ||
      this.props.loadingSubmitUpdatedAddress ||
      this.props.loadingDAF
    ) {
      spinner = <Spinner />;
    }

    // let documentTypesSpinner: any;
    // if (this.props.loadingDocumentTypes) {
    //   documentTypesSpinner = <Spinner />;
    // }
    let userInfoSpinner: any;
    if (this.props.loadingUserInfo) {
      userInfoSpinner = <Spinner />;
    }

    let viewOverviewOfBills: any;
    if (!this.state.showOverviewOfBills) {
      //   viewOverviewOfBills = <BalanceBilling />;
      // } else {
      viewOverviewOfBills = (
        <Fragment>
          {/* {overviewOfBills} */}
          {submitBills}
          {errorDisplay}
          {errorDisplaySubmitContactInformation}
          {errorDisplaySubmitClaim}
          {errorDisplayDAF}
          {errorDisplaySubmitUpdatedAddress}
          {discardBills}
          {providerBillsUpload}
          {patientsResponsibilityBillsUpload}
          {explanationOfBenefitsBillsUpload}
          {spinner}
          {viewProviderBills}
          {viewPatientsResponsibilityBills}
          {viewExplanationOfBenefitsBills}
          {viewDisputeAuthorizationForm}
          {/* {documentTypesSpinner} */}
          {userInfoSpinner}
          <Container fluid>
            <div className="inner-banner">
              <div className="inner-banner-title">
                <h3>{t("homePage.balanceBilling")}</h3>
                <Image
                  src={dollar}
                  alt="stock-image"
                  className={classes.stockimage}
                  data-test="stockIMG"
                />
              </div>
            </div>
            <div className="text-center">
              <h6 className="bill-heading">{t("uploadBill.newUpload")}</h6>
              <div className="step-circles">
                <ul>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="active"></li>
                  <li className="select"></li>
                </ul>
              </div>
            </div>

            <div className="quick-details-section quick-details-sec-space">
              <h4>
                {this.props.newUploadData.procedureLabel}
                <span>{this.props.newUploadData.beneficiarySelected}</span>
              </h4>
              <div className="row">
                <div className="col-md-7 col-sm-12">
                  <div className="quick-details quick-details-l">
                    <ul>
                      <li>
                        <h5>{t("balanceBilling.client")}</h5>
                        <span>{this.props.userInfo.TPA}</span>
                      </li>
                      <li>
                        <h5>{t("balanceBilling.groupId")}</h5>
                        <span>{this.props.userInfo.groupId}</span>
                      </li>
                      <li>
                        <h5>{t("balanceBilling.memberId")}</h5>
                        <span>{this.props.userInfo.memberId}</span>
                      </li>
                      <li>
                        <h5>{t("balanceBilling.ampsId")}</h5>
                        <span>{this.props.newUploadData.ampsId}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-5 col-sm-12">
                  <div className="quick-details quick-details-r">
                    <ul>
                      <li>
                        <h5>{t("submitBill.facility")}</h5>
                        <span>
                          {this.props.newUploadData.providerName}
                          {/* <Image
                    src={shield}
                    alt="shield"
                    className={classes.shieldIcon}
                  /> */}
                        </span>
                      </li>
                      <li>
                        <h5>{t("submitBill.dateOfService")}</h5>
                        <span>{this.props.newUploadData.dateOfService} </span>
                      </li>
                      <li>
                        <h5>{t("submitBill.charges")}</h5>
                        <NumberFormat
                          value={this.props.newUploadData.totalChargeAmount}
                          isNumericString={true}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                          decimalScale={2}
                          fixedDecimalScale={true}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="submissions">
              <h5>{t("submitBill.submissionCheckList")}</h5>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 flexInfo">
                  <div className="submission-box">
                    <h5>
                      {this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 1
                        )?.type}
                    </h5>
                    <div className="selectedFiles selected-files">
                      <div>
                        <span className="filesCount">
                          {this.props.providerBills
                            ? this.props.providerBills.length
                            : "0"}
                        </span>{" "}
                        {t("submitBill.fileUploaded")}
                      </div>
                    </div>
                    {providerBillsPreview}
                    <Button
                      className="btn-lg-border"
                      onClick={this.uploadProviderBillsHandler}
                      disabled={false}
                    >
                      <span>
                        {this.props.providerBills.length <= 0
                          ? `${t("balanceBilling.uploadBtn")} ${
                              this.props.documentTypes.length > 0 &&
                              this.props.documentTypes.find(
                                (title) => title.order === 1
                              )?.type
                            }`
                          : t("submitBill.addMore")}
                      </span>
                      <i>+</i>
                    </Button>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12 flexInfo">
                  <div className="submission-box submission-box-bdr">
                    <h5>
                      {this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 2
                        )?.type}
                    </h5>
                    <div className="selectedFiles selected-files">
                      <div>
                        {" "}
                        <Image src={sign} alt="sign" data-test="sign" />{" "}
                        {t("submitBill.docSigned")}{" "}
                      </div>
                    </div>
                    {disputeAuthorizationPreview}
                  </div>
                </div>
              </div>
            </div>
            <div className="submissions">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 flexInfo">
                  <div className="submission-box">
                    <h5>
                      {this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 3
                        )?.type}
                    </h5>
                    <div className="selectedFiles selected-files">
                      <div>
                        <span className="filesCount">
                          {this.props.patientsResponsibilityBills
                            ? this.props.patientsResponsibilityBills.length
                            : "0"}
                        </span>{" "}
                        {t("submitBill.fileUploaded")}
                      </div>
                    </div>

                    {patientsResponsibilityPreview}

                    <Button
                      className="btn-lg-border"
                      onClick={this.uploadPatientsResponsibilityBillsHandler}
                      disabled={false}
                    >
                      <span>
                        {this.props.patientsResponsibilityBills.length <= 0
                          ? `${t("balanceBilling.uploadBtn")} ${
                              this.props.documentTypes.length > 0 &&
                              this.props.documentTypes.find(
                                (title) => title.order === 3
                              )?.type
                            }`
                          : t("submitBill.addMore")}
                      </span>
                      <i>+</i>
                    </Button>
                  </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12 flexInfo">
                  <div className="submission-box submission-box-bdr">
                    <h5>
                      {this.props.documentTypes.length > 0 &&
                        this.props.documentTypes.find(
                          (title) => title.order === 4
                        )?.type}
                    </h5>
                    <div className="selectedFiles selected-files">
                      <div>
                        <span className="filesCount">
                          {this.props.explanationOfBenefitsBills
                            ? this.props.explanationOfBenefitsBills.length
                            : "0"}
                        </span>{" "}
                        {t("submitBill.fileUploaded")}
                      </div>
                    </div>

                    {explanationOfBenefitsPreview}

                    <Button
                      className="btn-lg-border"
                      onClick={this.uploadExplanationOfBenefitsBillsHandler}
                      disabled={false}
                    >
                      <span>
                        {this.props.explanationOfBenefitsBills.length <= 0
                          ? `${t("balanceBilling.uploadBtn")} ${
                              this.props.documentTypes.length > 0 &&
                              this.props.documentTypes.find(
                                (title) => title.order === 4
                              )?.type
                            }`
                          : t("submitBill.addMore")}
                      </span>
                      <i>+</i>
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-information">
              <h5>{t("submitBill.contactInformation")}</h5>
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <Input
                    label={t("submitBill.email")}
                    supportLabel=""
                    placeholder={t("placeHolder.johnEmail")}
                    elementLabelStyle={elementLabelStyle}
                    elementInputStyle={{}}
                    name="email"
                    errorText={this.state.errorEmail}
                    value={this.state.bestContactInfo.email}
                    onChange={(e) => this.handleChange(e)}
                  />
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="form-group">
                    <FormLabel className="form-label">
                      {t("submitBill.phone")}
                    </FormLabel>
                    <NumberFormat
                      format="(###) ###-####"
                      placeholder={t("placeHolder.phoneNo")}
                      name="phone"
                      value={this.state.bestContactInfo.phone}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    />
                    <span className="errorMsg">{this.state.errorPhone}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mainContainer">
              <div className="flexButtons">
                <CustomButton
                  label={t("submitBill.discard")}
                  clicked={this.discardBillsHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={false}
                />
                <CustomButton
                  label={t("submitBill.submit")}
                  clicked={this.submitHandler}
                  style={nextBtnStyle}
                  displayImg={false}
                  image=""
                  disabled={
                    // this.props.errorDocumentTypes ||
                    !this.props.documentTypes ||
                    (this.props.documentTypes &&
                      this.props.documentTypes.length <= 0)
                      ? true
                      : false
                  }
                />
              </div>
            </div>
          </Container>
        </Fragment>
      );
    }
    return <Fragment>{viewOverviewOfBills}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  // loadingDocumentTypes: state.fetchDocumentTypes.loading,
  // errorDocumentTypes: state.fetchDocumentTypes.error,
  documentTypes: state.fetchDocumentTypes.documentTypes,
  providerBills: state.browseImages.providerBills,
  patientsResponsibilityBills: state.browseImages.patientsResponsibilityBills,
  explanationOfBenefitsBills: state.browseImages.explanationOfBenefitsBills,
  disputeAuthorizationForm: state.disputeAuthorization.disputeAuthorizationForm,
  newUploadData: state.bbNewUpload.newUploadData,
  bestContactInfo: state.bestContactInfo,
  loadingSubmitBills: state.submitBills.loading,
  loadingUserInfo: state.fetchUserInfo.loadingUserInfo,
  submittedBills: state.submitBills.submitted,
  errorSubmitBills: state.submitBills.error,
  errorMessageSubmitBills: state.submitBills.errorMessage,
  submittedBillsDetails: state.submitBills.submittedBillsDetails,
  userInfo: state.fetchUserInfo.userInfo,
  loadingSubmitClaim: state.submitBalanceBillingClaim.loading,
  submittedSubmitClaim: state.submitBalanceBillingClaim.submitted,
  errorSubmitClaim: state.submitBalanceBillingClaim.error,
  errorMessageSubmitClaim: state.submitBalanceBillingClaim.errorMessage,
  loadingSubmitContactInformation: state.submitContactInformation.loading,
  submittedContactInformation: state.submitContactInformation.submitted,
  errorSubmitContactInformation: state.submitContactInformation.error,
  errorMessageSubmitContactInformation:
    state.submitContactInformation.errorMessage,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
  shouldUploadDocument: state.updatedAddress.shouldUploadDocument,
  updateAddressParams: state.updatedAddress.updateAddressParams,
  submittedDAF: state.submitDAF.submitted,
  loadingDAF: state.submitDAF.loading,
  errorDAF: state.submitDAF.error,
  errorMessageDAF: state.submitDAF.errorMessage,
  loadingSubmitUpdatedAddress: state.submitUpdatedAddress.loading,
  errorSubmitUpdatedAddress: state.submitUpdatedAddress.error,
  submittedSubmitUpdatedAddress: state.submitUpdatedAddress.submitted,
  errorMessageSubmitUpdatedAddress: state.submitUpdatedAddress.errorMessage,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchUserInfo: (patientId) => dispatch(actions.fetchUserInfo(patientId)),
  // onFetchDocumentTypes: (userId) =>
  //   dispatch(actions.fetchDocumentTypes(userId)),
  onSubmitBills: (formData) => dispatch(actions.submitBills(formData)),
  onSubmitContactInformation: (contactInfo) =>
    dispatch(actions.submitContactInformation(contactInfo)),
  onSubmitBalanceBillingClaim: (submitClaim) =>
    dispatch(actions.submitBalanceBillingClaim(submitClaim)),
  onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
    dispatch(actions.explanationOfBenefitsBills(explanationOfBenefitsBills)),
  onRemoveProviderBillsFiles: (providerBills) =>
    dispatch(actions.providerBills(providerBills)),
  onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
    dispatch(actions.patientsResponsibilityBills(patientsResponsibilityBills)),
  onResetDisputeAuthorizationFile: () =>
    dispatch(actions.resetDisputeAuthorizationFile()),
  onResetSubmitBills: () => dispatch(actions.resetSubmitBills()),
  onResetSubmitBalanceBillingClaim: () =>
    dispatch(actions.resetSubmitBalanceBillingClaim()),
  onResetSubmitContactInformation: () =>
    dispatch(actions.resetSubmitContactInformation()),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(actions.setBalanceBillViewState(balanceBillView)),
  onSubmitDAF: (formData) => dispatch(actions.submitDAF(formData)),
  onShouldUploadDocument: (shouldUplaod) =>
    dispatch(actions.shouldUploadDocument(shouldUplaod)),
  onSubmitUpdatedAddress: (updatedAddress) =>
    dispatch(actions.submitUpdatedAddress(updatedAddress)),
  onSubmitBestContactInfo: (bestContactInfo) =>
    dispatch(actions.fetchBestContactInfo(bestContactInfo)),
  onResetBestContactInfo: () => dispatch(actions.resetBestContactInfo()),

  onConstructUpdatedAddress: (name, value) =>
    dispatch(actions.constructUpdatedAddress(name, value)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SubmitBills));
